// GET LIST MOVIE
export const getListMovieRequest = "GET_LIST_MOVIE_REQUEST";
export const getListMovieSuccess = "GET_LIST_MOVIE_SUCCESS";
export const getListMovieFail = "GET_LIST_MOVIE_FAIL";
// GET MOVIE BY DATE
export const getListMovieByDateRequest = "GET_LIST_MOVIE_REQUEST";
export const getListMovieByDateSuccess = "GET_LIST_MOVIE_SUCCESS";
export const getListMovieByDateFail = "GET_LIST_MOVIE_FAIL";
// ADD NEW MOVIE
export const addNewMovieRequest = "ADD_NEW_MOVIE_REQUEST";
export const addNewMovieSuccess = "ADD_NEW_MOVIE_SUCCESS";
export const addNewMovieFail = "ADD_NEW_MOVIE_FAIL";
